const CssHelper = {
    addClass: (element, style) => {
        element.classList.add(style);
    },
    removeClass: (element, style) => {
        element.classList.remove(style);
    }
}

export default CssHelper;